import { createSelector } from "reselect";

export const getComments = (state) => state.humanComments;
export const getMatchHumanId = (state, props) => props.match.params.humanId;
export const getSelectedHumanId = (state, props) => props.human.id;

export const getSelectedHumanComments = createSelector(
  [getComments, getSelectedHumanId],
  (comments, humanId) => {
    const humanComments = [];
    for (let c of comments) {
      if (c.humanId === humanId) humanComments.push(c);
    }
    humanComments.sort((a, b) => b.createdAt.localeCompare(a.createdAt));

    return humanComments;
  }
);
